import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { TranslationsProvider } from '@/utilities/api/translations'

Vue.use(VueI18n);

await Office.onReady();
const locale = Office.context.displayLanguage || navigator.language || 'en-GB';
const messages = await TranslationsProvider.getTranslations(locale);

const i18n: VueI18n = new VueI18n({
    locale,
    silentTranslationWarn: true,
    messages: { [locale]: messages },
    missing: (locale, key) => key
        .replaceAll('_', ' ')
        .replace(/^terms\.(.*)$/, (_, t) => i18n.tc(t))
        .replace(/^./, c => c.toUpperCase())
});

export default i18n;